function pcPatchInventoryForm(recordId = null) {
  const form = pc$("#generic-form");
  if (!form || form.dataset.pc3Recon || !form.elements.pcDiluentMl) return;
  form.dataset.pc3Recon = "1";
  const metadata = recordId ? (pcMeta()[recordId] || {}) : {};
  const diluentLabel = form.elements.pcDiluentMl.closest("label");
  if (!diluentLabel) return;
  const row = document.createElement("div");
  row.className = "pc3-recon-extra span-2";
  row.innerHTML = `<div class="pc-inventory-grid">
    <label class="field"><span>Reconstitution date (optional)</span><input name="pcReconstitutedDate" type="date"><small>Use the date this current vial was reconstituted.</small></label>
    <label class="field"><span>Vial note (optional)</span><input name="pcVialNote" autocomplete="off" placeholder="e.g. Current vial / label note"><small>Private note stored with this device.</small></label>
  </div>`;
  diluentLabel.closest(".pc-inventory-grid")?.after(row);
  form.elements.pcReconstitutedDate.value = metadata.reconstitutedDate || "";
  form.elements.pcVialNote.value = metadata.vialNote || "";
  const beforeIds = new Set((pcState().inventory || []).map(x => x.id));
  form.addEventListener("submit", () => {
    if (!form.checkValidity()) return;
    const reconDate = form.elements.pcReconstitutedDate.value;
    const vialNote = form.elements.pcVialNote.value.trim();
    setTimeout(() => {
      const current = pcState().inventory || [];
      const id = recordId || current.find(x => !beforeIds.has(x.id))?.id;
      if (!id) return;
      const all = pcMeta();
      all[id] = {...(all[id] || {}), reconstitutedDate:reconDate, vialNote};
      pcSaveMeta(all);
      pcRenderInventoryExtras(); pcRenderRoutine(); pcRenderMonthlyReport();
    }, 80);
  });
}

function pcRenderInventoryExtras() {
  if (!pc$("#peptide-command-app")) return;
  const inventoryView = pc$("#inventory-view");
  const tableCard = pc$("#inventory-view .table-card");
  if (!inventoryView || !tableCard) return;
  let log = pc$("#pc3-reconstitution-log");
  if (!log) {
    log = document.createElement("section");
    log.id = "pc3-reconstitution-log";
    log.className = "card pc3-reconstitution-log";
    tableCard.after(log);
  }
  const st = pcState();
  const metadata = pcMeta();
  const rows = (st.inventory || []).map(item => {
    const d = pcSupply(item); const m = metadata[item.id] || {}; if (!d) return "";
    const concentration = m.vialAmount && m.diluentMl ? pcMg(m.vialAmount, m.vialUnit) / Number(m.diluentMl) : null;
    return `<article class="pc3-recon-row">
      <div class="pc3-recon-vial">${pcVialArt(item,d,m,true)}</div>
      <div><span>VIAL ${d.vialNumber} OF ${d.vials}</span><strong>${pcEsc(item.name)}</strong><small>${m.reconstitutedDate ? `Reconstituted ${pcShortDate(m.reconstitutedDate)}` : "Reconstitution date not entered"}</small></div>
      <div><span>BAC WATER / DILUENT</span><strong>${m.diluentMl > 0 ? `${pcNum(m.diluentMl)} mL` : "—"}</strong><small>${concentration ? `${pcNum(concentration)} mg/mL concentration` : "Add reconstitution details"}</small></div>
      <div><span>CURRENT VIAL</span><strong>${d.current} doses left</strong><small>${d.remaining} total across supply</small></div>
      <button class="table-action" data-edit-inventory="${item.id}">Edit log</button>
    </article>`;
  }).filter(Boolean).join("");
  log.innerHTML = `<div class="card-head"><div><p class="eyebrow">RECONSTITUTION LOG</p><h3>Current vial details</h3><p>Keep the vial amount, BAC water or diluent, reconstitution date, and remaining doses together.</p></div><span class="status-neutral">PRIVATE</span></div>
    <div class="pc3-recon-list">${rows || `<div class="pc3-routine-empty"><span>◇</span><div><strong>No vial log yet</strong><small>Add a peptide supply to begin.</small></div></div>`}</div>`;
}

function pcMonthStats() {
  const st = pcState(); const md = pcMeta(); const now = new Date();
  const year = now.getFullYear(), month = now.getMonth();
  const monthPrefix = `${year}-${String(month+1).padStart(2,"0")}`;
  const daysInMonth = new Date(year, month + 1, 0).getDate();
  let planned = 0;
  for (let day=1; day<=Math.min(daysInMonth, now.getDate()); day++) {
    const d = new Date(year, month, day);
    planned += (st.schedules || []).filter(s => pcOccurs(s,d)).length;
  }
  const logEntries = Object.entries(st.logs || {}).filter(([key]) => key.startsWith(monthPrefix));
  const completed = logEntries.filter(([,v])=>v==="complete").length;
  const skipped = logEntries.filter(([,v])=>v==="skip").length;
  const supplies = (st.inventory || []).map(i=>pcSupply(i)).filter(Boolean);
  const remaining = supplies.reduce((s,d)=>s+d.remaining,0);
  const vialsFinished = supplies.reduce((s,d)=>s+d.finished,0);
  const reconstituted = Object.values(md).filter(m => String(m.reconstitutedDate || "").startsWith(monthPrefix)).length;
  const peptides = new Set([...(st.schedules||[]).map(s=>s.name), ...(st.inventory||[]).map(i=>i.name)].filter(Boolean)).size;
  return {label:now.toLocaleDateString("en-US",{month:"long",year:"numeric"}), planned, completed, skipped, remaining, vialsFinished, reconstituted, peptides};
}

function pcRenderMonthlyReport() {
  if (!pc$("#peptide-command-app")) return;
  const view = pc$("#progress-view .progress-layout") || pc$("#progress-view");
  if (!view) return;
  let card = pc$("#pc3-monthly-report");
  if (!card) {
    card = document.createElement("section");
    card.id = "pc3-monthly-report";
    card.className = "card pc3-monthly-report";
    view.append(card);
  }
  const s = pcMonthStats();
  const rate = s.planned ? Math.round(s.completed / s.planned * 100) : 0;
  card.innerHTML = `<div class="pc3-report-head"><div><p class="eyebrow">MONTHLY COMMAND REPORT</p><h3>${pcEsc(s.label)}</h3><p>A clean snapshot built from your actual Peptide Command entries.</p></div><div class="pc3-report-score"><strong>${rate}%</strong><span>completed</span></div></div>
    <div class="pc3-report-grid"><div><span>Peptides tracked</span><strong>${s.peptides}</strong></div><div><span>Planned through today</span><strong>${s.planned}</strong></div><div><span>Completed</span><strong>${s.completed}</strong></div><div><span>Skipped</span><strong>${s.skipped}</strong></div><div><span>Doses remaining</span><strong>${s.remaining}</strong></div><div><span>Vials completed</span><strong>${s.vialsFinished}</strong></div><div><span>Reconstituted this month</span><strong>${s.reconstituted}</strong></div></div>
    <div class="pc3-report-actions"><button class="secondary-btn" id="pc3-copy-report">Copy summary</button><button class="primary-btn" id="pc3-print-report">Print / Save PDF</button></div>`;
}

function pcSavePreferences(patch) {
  const st = pcState();
  st.preferences = {...(st.preferences || {}), ...patch};
  pcWrite(PC_STATE_KEY, st);
}

function pcNotificationDefaults() {
  return {
    scheduleReminders:true, scheduleReminderMinutes:60,
    inventoryWarnings:true, lowSupplyThreshold:3,
    expirationWarnings:true, expirationLeadDays:14,
    weeklyCheckin:true, weeklyCheckinDay:0, weeklyCheckinTime:"09:00",
    browserNotifications:false, calendarPrivate:true, emailNotifications:false
  };
}

function pcSwitch(name, checked, label, help, disabled = false) {
  return `<label class="pc3-notify-row ${disabled ? "is-disabled" : ""}"><span><strong>${label}</strong><small>${help}</small></span><span class="pc3-switch"><input type="checkbox" data-pc-pref="${name}" ${checked ? "checked" : ""} ${disabled ? "disabled" : ""}><i aria-hidden="true"></i></span></label>`;
}
